/* unplugin-vue-components disabled */import { render } from "./tracker-base.vue?vue&type=template&id=8abc2aa6"
import script from "./tracker-base.vue?vue&type=script&lang=js"
export * from "./tracker-base.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/tracker/tracker-base.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8abc2aa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8abc2aa6', __exports__)) {
    api.reload('8abc2aa6', __exports__)
  }
  
  module.hot.accept("./tracker-base.vue?vue&type=template&id=8abc2aa6", () => {
    api.rerender('8abc2aa6', render)
  })

}


export default __exports__